import { Link } from 'gatsby';
import { GatsbyImage } from 'gatsby-plugin-image';
import PropTypes from 'prop-types';
import React from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import imgFallback from 'src/utils/image';
import * as classes from './NodeHighlightedServiceCard.module.scss';
import { useTheme } from 'src/hooks';
import ArrowIcon from 'src/svgs/arrow_right.svg';

export const NodeHighlightedServiceCard = ({ card }) => {
  const { pages } = useTheme();

  return (
    <Container fluid className={`position-relative shadow-service-card transition-2x overflow-hidden rounded-xl px-0 ${classes.container}`}>
      <Row noGutters className="h-100">
        <Col xs={12} className={`justify-content-center d-flex text-center ${classes.image__container}`}>
          <GatsbyImage
            alt={card.image?.alt ?? ''}
            image={card.image?.image?.asset?.gatsbyImageData ?? imgFallback}
            objectFit="contain"
            className={classes.image}
          />
        </Col>
        <Col
          xs={12}
          style={{ minHeight: '85px' }}
          className="d-flex justify-content-center justify-content-sm-start align-items-sm-start 
          flex-column px-3 py-3"
        >
          <Col className="px-0">
            <span className="text-size-lg font-weight-black text-black">{card.title}</span>
            <div className="text-gray-650">{card.description}</div>
          </Col>
          <Link to={card.url} className={`text-uppercase font-weight-black d-flex align-items-center ${classes.link}`}>
            {pages.services.more} <ArrowIcon className="" />
          </Link>
        </Col>
      </Row>
    </Container>
  );
};

NodeHighlightedServiceCard.propTypes = {
  card: PropTypes.shape({
    id: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
    image: PropTypes.shape({}).isRequired,
    displaySize: PropTypes.string.isRequired,
    url: PropTypes.string.isRequired,
  }).isRequired,
};
